export enum TipoNacionalidad
{
    Chileno = "Chileno",
    ExtranjeroResidente = "Extranjero Residente",
    ExtranjeroNoResidente = "Extranjero No Residente"
}